import React from "react";
import { useState, useEffect, useContext } from "react";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import "./App.css";

import { AuthProvider, AuthContext } from "./AuthContext";

import Login from "./components/auth/Login";
import Dashboard from "./components/auth/Dashboard";

import EnvioMasivo from "./pages/EnvioMasivo";
import Chat from "./pages/Chat";
import TagsPage from "./pages/Tags";
import QuickNotes from "./pages/QuickNotes";
import Stats from "./pages/Stats";
import Ingestion from "./pages/Ingestion";
import RemarketingMasivo from "./pages/RemarketingMasivo";

const PrivateRoute = ({ children }) => {
  const { token } = useContext(AuthContext);
  return token ? children : <Navigate to="/login" />;
};

function App() {
  // Renderiza la lista de conversaciones y la ventana de chat para la conversación seleccionada

  const [userName, setUserName] = useState("");

  useEffect(() => {
    const userStorage = localStorage.getItem("user");
    if (userStorage) {
      try {
        const userObj = JSON.parse(userStorage);
        setUserName(userObj.username);
      } catch (error) {
        setUserName("");
        console.error("Error al parsear el usuario de localStorage:", error);
      }
    }
  }, [userName]);

  return (
    <div className="app-container">
      <BrowserRouter>
        {/* MENU */}
        <div className="p-4 w-[300px] bg-green-200 sidebar-main">
          <h1 className="mb-3 app-name">WhatsApp CRM</h1>
          <nav>
            <ul className="sidebar-menu-list">
              <li className="mb-2 ml-4  ">
                <Link to="/chat">Chat</Link>
              </li>
              <li className="mb-2 ml-4  ">
                <Link to="/envio-masivo">Envio Masivo</Link>
              </li>
              <li className="mb-2 ml-4  ">
                <Link to="/etiquetas">Etiquetas</Link>
              </li>
              <li className="mb-2 ml-4  ">
                <Link to="/notas-rapidas">Notas rapidas</Link>
              </li>
              <li className="mb-2 ml-4  ">
                <Link to="/chat-antiguas">Conversaciones +48 horas</Link>
              </li>
              <li className="mb-2 ml-4  ">
                <Link to="/estadisticas">Estadisticas</Link>
              </li>
              <li className="mb-2 ml-4  ">
                <Link to="/remarketing-masivo">Remarketing Masivo</Link>
              </li>

              {/* <li className="mb-2 ml-4  ">
                <Link to="/entrenamiento">IA Entrenamiento</Link>
              </li> */}
            </ul>
          </nav>

           {/*Insertamos la imagen logo.png y lo centramos verticalmente  */}
            <div className="sidebar-logo-container">
              <figure>
                <img src="/logo.png" alt="Logo" className="sidebar-logo" />
              </figure>
              
            </div>



          <div className="sidebar-user-info">
              <p className="mb-3 mt-4 ml-4 italic font-bold text-blue-500">
                Usuario: <span className="text-green-700">{userName}</span>
              </p>

              <button
                className="mt-4 ml-4 italic font-bold text-red-500"
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("user");
                  window.location.href = "/login";
                }}
              >
                Logout
              </button>
            </div>

        </div>

        {/* RUTAS */}
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            <Route path="/" element={<Navigate to="/chat" />} />

            <Route
              path="/chat"
              element={
                <PrivateRoute>
                  <Chat showOldConversations={false} />
                </PrivateRoute>
              }
            />

            <Route
              path="/envio-masivo"
              element={
                <PrivateRoute>
                  <EnvioMasivo />
                </PrivateRoute>
              }
            />

            <Route
              path="/etiquetas"
              element={
                <PrivateRoute>
                  <TagsPage />
                </PrivateRoute>
              }
            />

              <Route
              path="/notas-rapidas"
              element={
                <PrivateRoute>
                  <QuickNotes />
                </PrivateRoute>
              }
            /> 

            <Route
              path="/chat-antiguas"
              element={
                <PrivateRoute>
                  <Chat showOldConversations={true} />
                </PrivateRoute>
              }
            />

            <Route
              path="/estadisticas"
              element={
                <PrivateRoute>
                  <Stats />
                </PrivateRoute>
              }
            />

            <Route 
              path="/remarketing-masivo"
              element={
                <PrivateRoute>
                  <RemarketingMasivo />
                </PrivateRoute>
              }
            />

            <Route
              path="/entrenamiento"
              element={
                <PrivateRoute>
                  <Ingestion />
                </PrivateRoute>
              }
            />   

            {/* Ruta para manejar errores 404 */}
            <Route path="*" element={<h1>404 - Página no encontrada</h1>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
